// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5839": "20ede6e2","7357": "7047eeaa","7935": "702052b4",}[chunkId] + ".css"
}